import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';

export interface CompanyRequisitesModalData {
  tariffName: string;
  periodLabel: string;
  priceLabel: string;
}

export interface CompanyRequisitesModalResult {
  saved: boolean;
}

@Component({
  selector: 'company-requisites-modal',
  templateUrl: './company-requisites-modal.component.html',
  styleUrls: ['./company-requisites-modal.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyRequisitesModalComponent {
  constructor(
    private ref: MatDialogRef<CompanyRequisitesModalComponent, CompanyRequisitesModalResult>,
    @Inject(MAT_DIALOG_DATA) public data: CompanyRequisitesModalData,
  ) {
  }

  onSaved(): void {
    this.ref.close({saved: true});
  }

  close(): void {
    this.ref.close();
  }
}
